<template>
  <div class="resize-wp" :style="style" :class="resizeSide">
    <slot></slot>
    <div class="btn-resize" @mousedown.prevent="resizeStart"></div>
  </div>
</template>

<script>
import { SIDE_MAP } from '@/contanst/index';
const DEFAULT_WIDTH = 300;
const NO_LIMIT_MAX = 99999;

export default {
  name: 'residePanel',
  inject: ['getIsWap'],
  props: {
    maxWidth: {
      type: Number,
      default: 0,
    },
    //以窗口宽度比率的最大宽度
    maxWidthRateOfWindow: {
      type: Number,
      default: 0,
    },
    minWidth: {
      type: Number,
      default: 0,
    },
    //以窗口宽度比率的最小宽度
    minWidthRateOfWindow: {
      type: Number,
      default: 0,
    },
    defaultWidth: {
      type: Number,
      default: DEFAULT_WIDTH,
    },
    // 标记是左扩展还是右扩展
    resizeSide: {
      type: String,
      default: SIDE_MAP.left,
    },
  },
  data() {
    return {
      isStartResize: false,
      startX: 0,
      startWidth: this.defaultWidth,
      sideWidth: this.defaultWidth,
      windowWidth: 0,
    };
  },
  computed: {
    realMaxWidth() {
      if (this.maxWidth) return this.maxWidth;
      if (this.maxWidthRateOfWindow) {
        return this.windowWidth * this.maxWidthRateOfWindow;
      }
      return NO_LIMIT_MAX;
    },
    realMinWidth() {
      if (this.minWidth) return this.minWidth;
      if (this.minWidthRateOfWindow) {
        return this.windowWidth * this.minWidthRateOfWindow;
      }
      return 0;
    },
    style() {
      return this.getIsWap() ? {} : {
        width: `${this.sideWidth}px`
      };
    },
  },
  created() {
    this.setWindowWidth();
    document.addEventListener('mousemove', this.doResize);
    document.addEventListener('mouseup', this.cancelResize);
    window.addEventListener('resize', this.windwoResize);
  },
  methods: {
    setWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
    resizeStart($event) {
      this.isStartResize = true;
      this.startX = $event.clientX;
    },
    doResize($event) {
      if (!this.isStartResize) return;
      const changeWidth = this.resizeSide === SIDE_MAP.left ? this.startX - $event.clientX : $event.clientX - this.startX;
      this.setSideWidth(this.startWidth + changeWidth);
    },
    cancelResize() {
      if (!this.isStartResize) return;
      this.isStartResize = false;
      this.startWidth = this.sideWidth;
    },
    windwoResize() {
      this.setWindowWidth();
      this.setSideWidth(this.sideWidth);
    },
    setSideWidth(width) {
      this.sideWidth = Math.max(this.realMinWidth, Math.min(this.realMaxWidth, width));
      this.$emit('sizeChange',{
        sideWidth: this.sideWidth,
      })
    }
  },
};
</script>
<style scoped>
.resize-wp .btn-resize {
  position: absolute;
  top: 0;
  width: 8px;
  height: 100%;
  cursor: ew-resize;
}
.resize-wp.left .btn-resize {
  left: -4px;
}
.resize-wp.right .btn-resize {
  right: -4px;
}
</style>
